import React from "react";

const LuxuryCarWash = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold">
          {" "}
          Advanced Interior Detailing (Chemical Wash) & Exterior Foam Wash
        </p>
        <ul className="list-disc text-black-500 font-bold">
          <li>Free Air Freshener</li>
        </ul>
        <ul className="list-disc text-black-500 ">
          <li>Interior Chemical Wash</li>
          <li>High Pressure Foam Wash</li>
          <li>Premium Foam Car Shampoo</li>
          <li>High Pressure Foam Wash</li>
          <li>Interior Deep Cleaning</li>
          <li>High Pressure Vacuum</li>
          <li>Dashboard & Interior Polish</li>
          <li>Tyre Polish</li>
          <li>
            <b>
              6-7 Seater will be changed RS 150 extra and 7+ Seater will be
              changed RS 300 extra
            </b>
          </li>
          <li>
            <b>
              CLEANING INSIDE BONNET IS AT OWNER'S RISK. - NOT RECOMMENDED (RS
              100 EXTRA)
            </b>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default LuxuryCarWash;
